import { Decimal, isDecimal, type TDecimal } from "@grafit/shared/utils/decimal";
import { isPlainDate, type PlainDate, plainDateFromISO, plainDateToISO } from "@grafit/shared/utils/plain-date";
import { registerCustom } from "superjson";

export const registerSuperJson = (): void => {
  registerCustom<TDecimal, string>(
    {
      isApplicable: (v): v is TDecimal => isDecimal(v),
      serialize: (v) => v.toJSON(),
      deserialize: (v) => Decimal(v),
    },
    "decimal.js",
  );

  registerCustom<PlainDate, string>(
    {
      isApplicable: isPlainDate,
      serialize: plainDateToISO,
      deserialize: plainDateFromISO,
    },
    "Temporal.PlainDate",
  );
};
